const parseScheduledDate = (maintenanceScheduled?: string | number | null) => {
  if (!maintenanceScheduled) return null
  const scheduledDate = new Date(maintenanceScheduled)
  if (Number.isNaN(scheduledDate.getTime())) return null
  return scheduledDate
}

export const isMaintenanceUnderway = ({
  maintenanceScheduled,
  maintenanceOnGoing,
  forceUnderway = false,
}: {
  maintenanceScheduled?: string | number | null
  maintenanceOnGoing?: boolean
  forceUnderway?: boolean
}) => {
  if (forceUnderway) return true
  if (maintenanceOnGoing) return true
  const scheduledDate = parseScheduledDate(maintenanceScheduled)
  if (!scheduledDate) return false
  return new Date() > scheduledDate
}

export const shouldShowMaintenanceBanner = ({
  maintenanceScheduled,
  maintenanceOnGoing,
  maintenanceBannerClosedFor,
  forceUnderway = false,
}: {
  maintenanceScheduled?: string | number | null
  maintenanceOnGoing?: boolean
  maintenanceBannerClosedFor?: string | number | null
  forceUnderway?: boolean
}) => {
  if (forceUnderway || maintenanceOnGoing) return true
  const scheduledDate = parseScheduledDate(maintenanceScheduled)
  if (!scheduledDate) return false
  if (new Date() > scheduledDate) return true
  if (
    maintenanceBannerClosedFor &&
    maintenanceScheduled &&
    maintenanceBannerClosedFor === maintenanceScheduled
  ) {
    return false
  }
  return true
}

export const getMaintenanceScheduledDate = (maintenanceScheduled?: string | number | null) =>
  parseScheduledDate(maintenanceScheduled)
